import store from '@/store'

export default (to, from, next) => ({
    allow: store.getters.is_order_placement_allowed,
    redirect: { name: 'sign-up' },
})